import { deleteToken, getToken, onMessage } from 'firebase/messaging';
import { getFirebaseMessaging } from './firebase_service';

const getFcmToken = async () => {
  try {
    const messaging = await getFirebaseMessaging();
    if (!messaging) return null;
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration: registration,
    });
    return token || null;
  } catch (error) {
    console.error('FCM token error:', error);
    return null;
  }
};

export const requestNotificationPermission = async () => {
  if (!('Notification' in window) || !('serviceWorker' in navigator)) return null;

  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return null;
    return getFcmToken();
  } catch (error) {
    console.error('Notification permission error:', error);
    return null;
  }
};

export const notificationListener = async (onForegroundMessage) => {
  const messaging = await getFirebaseMessaging();
  if (!messaging) return () => {};

  return onMessage(messaging, (payload) => {
    onForegroundMessage && onForegroundMessage(payload);
  });
};

export const clearFcmToken = async () => {
  try {
    const messaging = await getFirebaseMessaging();
    if (messaging) await deleteToken(messaging);
  } catch (error) {
    console.error('FCM token delete error:', error);
  }
};
